/** Field labels where the copied value is a staff-system identifier safe for analytics debug attributes. */
export const INTERNAL_ID_COPY_FIELD_LABELS = new Set([
  "PGA ID",
  "Facility ID",
  "ID",
  "Education Requirement",
  "COP number",
  "note link"
]);

export function isInternalIdCopyField(label?: string): boolean {
  if (!label) return false;
  return INTERNAL_ID_COPY_FIELD_LABELS.has(label.trim());
}

export function buildCopyAriaLabel({
  ariaLabel,
  copyFieldLabel
}: {
  ariaLabel?: string;
  copyFieldLabel?: string;
  copyFieldId?: string;
}): string {
  if (ariaLabel) return ariaLabel;
  if (copyFieldLabel) return `Copy ${copyFieldLabel}`;
  return "Copy";
}

export type CopyAnalyticsAttributes = {
  "data-amp-track-copy-field"?: string;
  "data-amp-track-copy-field-id"?: string;
};

/** Amplitude autocapture metadata for copy controls. IDs are emitted only for allowlisted internal-ID fields. */
export function getCopyAnalyticsAttributes({
  copyFieldLabel,
  copyFieldId
}: {
  copyFieldLabel?: string;
  copyFieldId?: string;
}): CopyAnalyticsAttributes {
  if (!copyFieldLabel) return {};

  const attributes: CopyAnalyticsAttributes = {
    "data-amp-track-copy-field": copyFieldLabel
  };

  if (copyFieldId && isInternalIdCopyField(copyFieldLabel)) {
    attributes["data-amp-track-copy-field-id"] = copyFieldId;
  }

  return attributes;
}
